import { PaymentMethod } from '../models/types';
import log from './logger';

export const callToDevice = (func, ...args) => {
  return new Promise((resolve, reject) => {
    if (window.AndroidInterface && typeof window.AndroidInterface[func] === 'function') {
      // log.debug(`callToDevice::${func}(${args})`);
      try {
        let answer = window.AndroidInterface[func](...args);
        resolve(answer);
      } catch (e) {
        log.error(e);
        reject(e);
      }
    } else {
      reject({error: 'apk_not_found', message: 'AndroidInterface not available'});
    }
  });
};

export const removeAndroidEvent = (event) => {
  document.applicationEventHandlers = document.applicationEventHandlers || {};

  if (document.applicationEventHandlers[event]) {
    const { handler, capture } = document.applicationEventHandlers[event];
    document.removeEventListener(event, handler, capture);

    delete document.applicationEventHandlers[event];
  }
};

export const attachAndroidEvent = (event, handler, capture = false) => {
  document.applicationEventHandlers = document.applicationEventHandlers || {};

  removeAndroidEvent(event);

  document.applicationEventHandlers[event] = {
    handler,
    capture,
  };

  document.addEventListener(event, handler, capture);
};

export const saveModel = async (id, clazz, json) => {
  return callToDevice('saveModel', id, clazz, JSON.stringify(json), new Date().getTime(), new Date().getTime()).then((data) => data).catch((e) => e);
};

export const getModel = async (id, clazz) => {
  callToDevice('getModel', id, clazz.name).then((model) => {
    let data = JSON.parse(model);
    let obj = new clazz(JSON.parse(data.json));
    return obj;
  }).catch((e) => {
    return Promise.reject(e);
  });
};

export const payToPhone = async (amount, type = PaymentMethod.CARD) => {
  try {
    await callToDevice('payToPhone', amount * 100, type);
  } catch (e) {
    throw e;
  }
};

export const nfcRefund = async (amount, type = PaymentMethod.CARD, transactionId, mid) => {
  try {
    await callToDevice('refund', amount * 100, transactionId, mid, type);
  } catch (e) {
    throw e;
  }
};

export const testPayToPhone = (amount, type = PaymentMethod.CARD, paymentParams) => {
  return callToDevice('testPayToPhone', amount * 100, type, paymentParams).catch((e) => log.error);
};

export const checkCameraPermission = async () => {
  return callToDevice('checkCameraPermission');
};

export const clearModels = async () => {
  return callToDevice('clearModels').then((data) => data).catch((e) => e);
};

export const createEvent = (name, data) => {
  const event = new CustomEvent(name, { detail: data });
  document.dispatchEvent(event);
};
